import Loader from "react-loader-spinner";
import { Fragment, useRef, useState } from "react";
import { Accordion, Button, Card, Col, Form, Row, Table } from "react-bootstrap";
import { Calendar2Date, CheckLg, DashCircleFill, EnvelopeOpen, PlusSquare, Trash } from "react-bootstrap-icons";
import { useDispatch, useSelector } from "react-redux";
import { setDialog } from "../../store/api/GetAllProduct";
import { addNewMessage, deleteMessage } from "../../store/api/Services";
import DatePicker from "react-datepicker2";
import { addNewEvent, deleteEvent, getServiceEvents } from "../../store/api/CustomerApi";

const ServiceEvents_Messages = (props) => {
    const dispatch = useDispatch();
    const eventData = useRef({});
    const messageInput = useRef();
    const { serviceID, serviceType, customerID } = props;
    const [pending, setPending] = useState(false);
    const [eventError, setEventError] = useState({});
    const [showAddEvent, setShowAddEvent] = useState(false);
    const { messageList, eventList } = useSelector(state => { return { messageList: state.service.serviceMessageList, eventList: state.customerDataReducer.serviceEventList } });
    function addMessage(e) {
        if (e.key && e.key !== "Enter") {
            return;
        }
        if (messageInput.current.value === '') {
            return;
        }
        let data = {};
        data.ServiceID = serviceID;
        data.ServiceType = serviceType;
        data.MessageBody = messageInput.current.value;
        dispatch(addNewMessage(data, () => { messageInput.current.value = "" }));
    }
    function addEvent(e) {
        if (e.key && e.key !== "Enter") {
            return;
        }
        let er = {};
        if (!eventData.current.Description || eventData.current.Description === '') {
            er.Description = 'N';
        }
        setEventError(er);
        if (Object.keys(er).length > 0) {
            return;
        }
        setPending(true);
        const pAlarmDate = document.getElementsByName("AlarmDate")[0]?.value;
        if (pAlarmDate === "") {
            eventData.current.NextDate = null;
        }
        eventData.current.CustomerID = customerID;
        eventData.current.IsPreCustomer = false;
        eventData.current.AttachmentID = serviceID;
        eventData.current.AttachmentType = serviceType;
        const onSuccess = () => {
            setPending(false);
            eventData.current = {};
            setShowAddEvent(false);
            dispatch(getServiceEvents(serviceID, serviceType));
        }
        dispatch(addNewEvent(eventData.current, onSuccess));
    }
    const cancelEvent = () => {
        eventData.current = {};
        setEventError({});
        setShowAddEvent(false);
    }
    return (
        <Row>
            <Accordion defaultActiveKey="0">
                <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="0" style={{ backgroundColor: "#6ec3d4", textAlign: "right", fontSize: "14px" }}>
                        <EnvelopeOpen size={18} />&nbsp;پیام های داخلی</Accordion.Toggle>
                    <Accordion.Collapse eventKey="0">
                        <Card.Body style={{ textAlign: 'right', backgroundColor: "#f8fafabf" }}>
                            <Col md={6} className='form-group' style={{ marginTop: "2px" }}>
                                <Form.Control as="textarea" rows={1} style={{ width: "85%", display: "inline-block" }}
                                    ref={messageInput} placeholder="متن پیام را وارد کنید" />
                                <Button className='group-Btn' style={{ marginTop: "-30px" }} onClick={addMessage}><PlusSquare size={18} /></Button>
                            </Col>
                            <Table responsive className='fixedTable' style={{ marginBottom: "0px" }}>
                                <thead>
                                    <tr>
                                        <th style={{ width: window.innerWidth >= 414 ? "40%" : "90%" }}>متن پیام</th>
                                        {window.innerWidth >= 414 &&
                                            <Fragment>
                                                <th style={{ width: "15%" }}>تاریخ ثبت</th>
                                                <th style={{ width: "20%" }}>ثبت کننده</th>
                                                <th style={{ width: "15%" }}>سمت</th>
                                            </Fragment>
                                        }
                                        <th style={{ width: "10%" }}>&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {messageList === "PENDING" &&
                                        <tr>
                                            <td colSpan={4} style={{ textAlign: "center", width: "100%" }}><Loader type="BallTriangle" width={20} height={20} color="#bb1370" /></td>
                                        </tr>
                                    }
                                    {messageList && Array.isArray(messageList) &&
                                        messageList.map((item, i) =>
                                            <tr key={i} className="resultTableRow">
                                                <td style={{ width: window.innerWidth >= 414 ? "40%" : "90%" }}>{item.MessageBody}</td>
                                                {window.innerWidth >= 414 &&
                                                    <Fragment>
                                                        <td style={{ width: "15%" }}>{item.PCreationDate}</td>
                                                        <td style={{ width: "20%" }}>{item.CreateByName}</td>
                                                        <td style={{ width: "15%" }}>{item.DepartmentName}</td>
                                                    </Fragment>
                                                }
                                                <td style={{ width: "10%" }} onClick={() => {
                                                    dispatch(setDialog({
                                                        status: 'show',
                                                        arrayBtn: ['yes', 'no'],
                                                        dialogTitle: 'حذف پیام',
                                                        dialogText: 'آیا از حذف مطمئن هستید؟',
                                                        okOperation: deleteMessage(item.ID)
                                                    }))
                                                }}><Trash size={16} style={{ color: "red" }} className="rowBtn" /></td>
                                            </tr>)
                                    }
                                </tbody>
                            </Table>
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
                <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="1" style={{ backgroundColor: "#8ca9e9", textAlign: "right", fontSize: "14px" }}>
                        <Calendar2Date size={18} />&nbsp;رویدادها
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="1">
                        <Card.Body style={{ textAlign: "right", backgroundColor: "#f8faff8c" }}>
                            {showAddEvent &&
                                <div style={{ border: "1px solid #b1b1b1", borderRadius: "3px", padding: "5px" }}>
                                    <Row>
                                        <div className="col-md-2 form-group">
                                            <label>تاریخ پیگیری</label>
                                            <DatePicker name="AlarmDate" isGregorian={false} timePicker={false} className="form-control"
                                                onChange={value => { eventData.current.NextDate = value.local("en").format("YYYY/MM/DD") }} />
                                        </div>
                                        <div className="col-md-6 form-group">
                                            <label>شرح رویداد</label><span style={{ color: "red", fontSize: "14px" }}>*</span>
                                            <input className="form-control" onChange={e => eventData.current.Description = e.target.value} onKeyDown={addEvent} />
                                            {eventError.Description && <small className="errors">شرح رویداد الزامی است</small>}
                                        </div>

                                    </Row>
                                    <Button variant="success" className="group-Btn mt-2" onClick={addEvent}>
                                        {!pending && <Fragment><CheckLg />&nbsp;ثبت رویداد</Fragment>}
                                        {pending && <Fragment> <Loader type="BallTriangle" color="white" height={15} width={15} style={{ display: "inline-block" }} />&nbsp; منتظر بمانید</Fragment>}
                                    </Button>
                                    <Button variant="danger" className="group-Btn mt-2" onClick={cancelEvent}><DashCircleFill size={16} />&nbsp;انصراف</Button>
                                </div>
                            }
                            {!showAddEvent && <Button className="group-Btn-smalll" style={{ textAlign: "center" }} onClick={() => setShowAddEvent(true)}><PlusSquare size={18} /></Button>}
                            <Table responsive className="mt-1 fixedTable">
                                <thead>
                                    <tr>
                                        {window.innerWidth >= 414 && <th style={{ width: "15%" }}>تاریخ رویداد</th>}
                                        <th style={{ width: window.innerWidth >= 414 ? "55%" : "100%" }}>شرح رویداد</th>
                                        {
                                            window.innerWidth >= 414 &&
                                            <Fragment>
                                                <th style={{ width: "10%" }}>تاریخ پیگیری</th>
                                                <th style={{ width: "10%" }}>ثبت کننده</th>
                                                <th style={{ width: "10%" }}></th>
                                            </Fragment>
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    {eventList === "PENDING" &&
                                        <tr>
                                            <td colSpan={6} style={{ textAlign: "center", width: '100%' }}>
                                                <Loader type="BallTriangle" color="#bb1370" height={30} />
                                            </td>
                                        </tr>
                                    }
                                    {
                                        eventList?.Data && Array.isArray(eventList.Data) &&
                                        eventList.Data.map((item, i) =>
                                            <tr key={i} className="resultTableRow">
                                                {window.innerWidth >= 414 && <td style={{ width: "15%" }}>{item.PCreationDate}</td>}
                                                <td style={{ width: window.innerWidth >= 414 ? "55%" : "100%" }}>{item.Description}</td>
                                                {
                                                    window.innerWidth >= 414 &&
                                                    <Fragment>
                                                        <td style={{ width: "10%" }}>{item.pNextDate === "" ? "..." : item.pNextDate}</td>
                                                        <td style={{ width: "10%" }}>{item.CreateByName}</td>
                                                        <td style={{ width: "10%" }}><Trash size={18} color="red" className="rowBtn" onClick={(item) => {
                                                            dispatch(setDialog({
                                                                status: 'show',
                                                                arrayBtn: ['yes', 'no'],
                                                                dialogTitle: 'حذف رویداد',
                                                                dialogText: 'آیا از حذف مطمئن هستید؟',
                                                                okOperation: deleteEvent(item.ID, () => dispatch(getServiceEvents(serviceID, serviceType)))
                                                            }))
                                                        }} /></td>
                                                    </Fragment>
                                                }
                                            </tr>)
                                    }
                                </tbody>
                            </Table>

                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
            </Accordion>
        </Row>
    )
}
export default ServiceEvents_Messages;